import { Injectable, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ApiService, UserInfo } from './api.service'
import { MenuService } from './menu.service'
import { SalesforceService } from './salesforce.service'
import { environment } from '../../environments/environment'


@Injectable({
    providedIn: 'root'
})
export class HomeLinksService{

    userInfo: UserInfo;

    servicesInPro: HomeLink[] = ['my-samples', 'my-sales', 'my-galleries', 'fabricator-rewards']

    constructor(
        private router: Router,
        private api: ApiService,
        private menuService: MenuService,
        private canvas: SalesforceService
    ) {
        this.userInfo = this.api.userInfo.getValue()
    }

    goToBenefits(checkFab = false) {
        if (checkFab && (this.userInfo.accountType == 'FABRICATOR' || this.userInfo.accountType == 'INSTALLER')) {
            this.goToService('fabricator-rewards')
        } else {
            this.goToService('benefits')
        }
    }

    goToMyCommisions() {
        this.goToService('my-bonuses')
    }

    goToSupplierPortalRegistration() {
        this.goToService('suppliers')
    }

    goToClaims() {
        this.goToService('my-claims')
    }

    goToSamples() {
        this.goToService('my-samples')
    }

    goToDisplays() {
        this.goToService('my-displays')
    }

    goToSales() {
        this.goToService('my-sales')
    }

    goToGalleries() {
        this.goToService('my-galleries')
    }

    goToVisualizers() {
        this.goToService('visualizers')
    }

    private goToService(service: HomeLink) {
        if(this.isInSalesforce(service)){
            const sfUrl = this.mapServiceToSf(service)
            if(!sfUrl){
                this.router.navigate([service])
            } else {
                window.top!.postMessage({
                    type: "navigateTo",
                    communityPage: "",
                    externalUrl: sfUrl,
                    params: "",
                    newTab: false
                }, environment.salesforceUrl);
            }
        } else {
            this.router.navigate([service])
        }
    }

    private mapServiceToSf(service: HomeLink) {
        switch (service) {
            case 'fabricator-rewards':
                return environment.salesforceUrl + '/s/werewards'
            case 'benefits':
                return environment.salesforceUrl + '/s/we?route=landingkb'
            case 'my-projects':
                return environment.salesforceUrl + '/s/myprojectsnew?path=projects'
            case 'my-bonuses':
                return environment.salesforceUrl + '/s/mybonuses'
            case 'suppliers':
                return environment.salesforceUrl + '/s/company-profile'
            case 'my-claims':
                return environment.salesforceUrl + '/s/myqualityclaimsnew'
            case 'my-samples':
                return environment.salesforceUrl + '/s/mysamples'
            case 'my-displays':
                return environment.salesforceUrl + '/s/mydisplays'
            case 'my-sales':
                return environment.salesforceUrl + '/s/mysalesnew'
            case 'my-galleries':
                return environment.salesforceUrl + '/s/mygalleriesnew'
            case 'my-financial-portal':
                return environment.salesforceUrl + '/s/financialPortal'
            case 'my-leads':
                return environment.salesforceUrl + '/s/myclientsnew'
            case 'visualizers':
                return environment.salesforceUrl + '/s/visualizer'
            default:
                return null;
        }
    }

    private isInSalesforce(service: HomeLink){
        return !!(this.canvas.isCanvas() && window.top && !this.servicesInPro.includes(service))
    }

    // External link or sf canvas
    goToProjects(){
        if(this.isInSalesforce('my-projects')){
            this.goToService('my-projects')
        } else {
            let item = this.userInfo.mainMenu.items.find((item) => item.code === 'ctop-my-projects')
            if(item) this.menuService.goTo(item)
        }
    }

    // External link or sf canvas
    goToFinancialPortal() {
        if(this.isInSalesforce('my-financial-portal')){
            this.goToService('my-financial-portal')
        } else {
            let item = this.userInfo.mainMenu.items.find((item) => item.code === 'my-financial-portal')
            if(item) this.menuService.goTo(item)
        }
    }

    // External link or sf canvas
    goToLeads(status?: string) {
        if(this.isInSalesforce('my-leads')){
            const sfUrl = this.mapServiceToSf('my-leads')
            const url = sfUrl ? (status ? `${sfUrl}?status=${status}` : sfUrl) : null
            if(!url){
                this.router.navigate(['my-leads'])
            } else {
                window.top!.postMessage({
                    type: "navigateTo",
                    communityPage: "",
                    externalUrl: url,
                    params: "",
                    newTab: false
                }, environment.salesforceUrl);
            }
        } else {
            let item = this.userInfo.mainMenu.items.find((item) => item.code === 'my-leads')
            if(item) this.menuService.goTo(item, false, status)
        }
    }

    goToWecommerce(){
        let item = this.userInfo.mainMenu.items.find((item) => item.code === 'we-store')
        if (item) this.menuService.goTo(item)
    }

    // External link
    goToMyRates() {
        let item = this.userInfo.mainMenu.items.find((item) => item.code === 'my-rates')
        if(item) this.menuService.goTo(item)
    }

    // External link
    goToDesignerRate() {
        let item = this.userInfo.mainMenu.items.find((item) => item.code === 'designer-rate')
        if(item) this.menuService.goTo(item)
    }

    // External link
    goToTechnicalDocumentation() {
        let item = this.userInfo.mainMenu.items.find((item) => item.code === 'technical-documentation')
        if(item) this.menuService.goTo(item)
    }

    // External link
    goToInspiration() {
        let item = this.userInfo.otherServicesMenu.items.find((item) => item.code === 'inspiration')
        if(item) this.menuService.goTo(item)
    }

    // External link
    goToShowroomAppointment() {
        let item = this.userInfo.otherServicesMenu.items.find((item) => item.code === 'showroom-appointment')
        if(item) this.menuService.goTo(item)
    }

    // External link
    goToECosentino() {
        let item = this.userInfo.mainMenu.items.find((item) => item.code === 'e-cosentino')
        if(item) this.menuService.goTo(item)
    }

}


type HomeLink =
    'fabricator-rewards' |
    'benefits' |
    'my-bonuses' |
    'my-projects' |
    'suppliers' |
    'my-claims' |
    'my-samples' |
    'my-displays' |
    'my-sales' |
    'my-galleries' |
    'my-financial-portal' |
    'my-leads' |
    'visualizers';
